var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('country-flag',{attrs:{"country":_vm.country}}),_vm._v(" "+_vm._s(_vm.countryName)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }